export default (paymentMethod) => {
  if (!paymentMethod) {
    return null;
  }
  const paymentMethodUpperCase = paymentMethod.toUpperCase();
  
  // eslint-disable-next-line no-restricted-globals
  if (!isNaN(paymentMethod)) {
    return 'CREDIT_CARD';
  }
  if (paymentMethodUpperCase.includes('STORED_CARD')) {
    return 'CREDIT_CARD';
  }
  if (paymentMethodUpperCase.includes('PAYPAL')) {
    return 'PAYPAL';
  }
  if (paymentMethodUpperCase.includes('KLARNA')) {
    return 'KLARNA';
  }
  if (paymentMethodUpperCase.startsWith('ADYEN')) {
    if (paymentMethodUpperCase.includes('ADYEN_V2')) {
      return 'ADYEN_V2';
    }
    return 'ADYEN';
  }
  if (paymentMethodUpperCase.includes('AFTERPAY')) {
    return 'AFTERPAY';
  }
  if (paymentMethodUpperCase.includes('CLEARPAY')) {
    return 'CLEARPAY';
  }
  if (paymentMethodUpperCase.includes('WECHATPAY')) {
    return 'WECHATPAY';
  }
  if (paymentMethodUpperCase.includes('APPLEPAY')) {
    return 'APPLEPAY';
  }
  if (paymentMethodUpperCase.includes('GOOGLEPAY')) {
    return 'GOOGLEPAY';
  }
  if (paymentMethodUpperCase.includes('KCP_BANK')) {
    return 'KCP_BANK';
  }
  if (paymentMethodUpperCase.includes('KCP_CARD')) {
    return 'KCP_CARD';
  }
  if (paymentMethodUpperCase.includes('IDEAL')) {
    return 'IDEAL';
  }
  if (paymentMethodUpperCase.includes('MULTIBANCO')) {
    return 'MULTIBANCO';
  }
  if (paymentMethodUpperCase.includes('UNIONPAY')) {
    return 'UNIONPAY';
  }
  if (paymentMethodUpperCase.includes('BCMC')) {
    return 'BCMC';
  }
  if (paymentMethodUpperCase.includes('SPLITIT')) {
    return 'SPLITIT';
  }
  if (paymentMethodUpperCase.includes('LAYBUY')) {
    return 'LAYBUY';
  }
  if (paymentMethodUpperCase.includes('OPENPAY')) {
    return 'OPENPAY';
  }
  if (paymentMethodUpperCase.includes('ARVATO')) {
    return 'ARVATO';
  }
  if (paymentMethodUpperCase.includes('ZIPPAY')) {
    return 'ZIPPAY';
  }
  if (paymentMethodUpperCase.includes('SEPA')) {
    return 'SEPA';
  }
  if (paymentMethodUpperCase.includes('CARD')) {
    return 'CREDIT_CARD';
  }
  if (paymentMethodUpperCase.includes('QUADPAY')) {
    return 'QUADPAY';
  }
  if (paymentMethodUpperCase.includes('MODE')) {
    return 'MODE';
  }
  if (paymentMethodUpperCase.includes('SEZZLE')) {
    return 'SEZZLE';
  }
  if (paymentMethodUpperCase.includes('PAYVYNE')) {
    return 'PAYVYNE';
  }
  if (paymentMethodUpperCase.includes('SPOTII')) {
    return 'SPOTII';
  }
  if (paymentMethodUpperCase.includes('HUMM')) {
    return 'HUMM';
  }
  if (paymentMethodUpperCase.includes('ATOME')) {
    return 'ATOME';
  }
  if (paymentMethodUpperCase.includes('ALIPAY_PLUS')) {
    return 'ALIPAY_PLUS';
  }
  if (paymentMethodUpperCase.includes('RAZORPAY')) {
    return 'RAZORPAY';
  }
  if (paymentMethodUpperCase.includes('FRASERS_PLUS')) {
    return 'FRASERS_PLUS';
  }
  if (paymentMethodUpperCase.includes('OPTTY')) {
    return 'OPTTY';
  }
  if (paymentMethodUpperCase.includes('FLEX')) {
    return 'FLEX';
  }
  if (paymentMethodUpperCase.includes('PCI_PAL')) {
    return 'PCI_PAL';
  }
  
  return null;
};
